export const seamComponentsClassName = 'seam-components'
